import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { useNavigate, useParams } from "react-router-dom";
import { MenuIcon, EditIcon, TrashIconB } from "assets/images/icons/icons";
import useAxiosFunction from "hooks/useAxios";
import { userInfoState } from "recoil/userStore";
import moment from "moment";

const TrendDetail = () => {
  const userInfo = useRecoilValue(userInfoState);
  const navigate = useNavigate();
  const [trendData, setTrendData] = useState([]);
  const { apiUrls, axiosFetch } = useAxiosFunction();
  const { postId } = useParams();

  const onDetailArticle = (e) => {
    e.preventDefault();
    navigate("/trend/case");
  };

  const onEditHandler = (e) => {
    e.preventDefault();
    navigate(`/trend/case/edit/${postId}`);
  };

  const onDeleteHandler = (e) => {
    e.preventDefault();

    axiosFetch({
      method: "post",
      url: apiUrls.deleteTrend,
      requestConfig: { postId: postId },
    })
      .then((res) => {
        if (res.success) {
          navigate("/trend");
        }
      })
      .catch((err) => {
        console.log("[ERROR] login : ", err);
      });
  };

  useEffect(() => {
    axiosFetch({
      method: "get",
      url: apiUrls.getTrendDetail(postId),
      requestConfig: null,
    })
      .then((res) => {
        if (res.success) {
          setTrendData(res.result[0]);
        }
      })
      .catch((err) => {
        console.log("[ERROR] get trend info : ", err);
      });
  }, []);

  function createMarkup() {
    return { __html: trendData.content };
  }

  return (
    <div className="detail-box">
      <div className="detail-title-box">
        <div className="detail-writer">{trendData.title}</div>
        <div>
          <ul className="detail-writer">
            <li>
              작성자 :{" "}
              {trendData?.customer_id === "admin"
                ? "관리자"
                : trendData?.customer_id}
            </li>
            <li>{moment(trendData.date).format("YYYY/MM/DD")}</li>
            <li>조회수: {trendData?.read_count}</li>
          </ul>
        </div>
      </div>
      <div className="detail-content-box">
        <div
          className="board-content"
          dangerouslySetInnerHTML={createMarkup()}
        ></div>
        <div className="board-btn">
          <div className="btn-box">
            {userInfo.userInfo && (
              <>
                <button onClick={onEditHandler}>
                  <EditIcon className="btn-ico" />
                  수정
                </button>
                <button onClick={onDeleteHandler}>
                  <TrashIconB className="btn-ico" />
                  삭제
                </button>
              </>
            )}
            <button onClick={onDetailArticle}>
              <MenuIcon className="btn-ico" />
              목록
            </button>
          </div>
        </div>
      </div>
      <div className="boardListArea"></div>
    </div>
  );
};

export default TrendDetail;
